module.exports = __webpack_public_path__ + "img/627e13c.png";